export const SURFACE_MCP_FIRST_OPEN_INTRO_MODAL_KEY = 'surfaceMcpFirstOpenIntroModal';
export const SURFACE_MCP_ONBOARDING_MODAL_KEY = 'mcpOnboardingModal';
